import axios from "axios";

export const state = {
    otherpatients: [],
};

export const getters = {
    otherpatients: state => state.otherpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.otherpatients = newValue
    },
};

export const actions = {
    fetchOtherPatients({ commit }) {
        axios.get('/otherpatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterOtherPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterotherpatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
